export default {
  overview: [],
  userFreeDays: []
};
